import { ExchangeRuleScopeEmailSelection } from '@nirvana/shared/dtos/types/policies/common';
import { ValidationResult } from '../../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../../../../../utils/translator.helper';
import { RequiredValidator } from '../../../../../../../../../../ui/gzForm/validators/required.validator';

// validate rule scope selection group
export function validateScopeGroup(
  from: ExchangeRuleScopeEmailSelection,
  to: ExchangeRuleScopeEmailSelection
): ValidationResult {
  if (from === ExchangeRuleScopeEmailSelection.ANY && to === ExchangeRuleScopeEmailSelection.ANY) {
    return {
      valid: false,
      error: translateFn('You cannot exclude all senders and all recipients from antimalware filtering.'),
    };
  }

  return { valid: true };
}

// validators for the scope group
export const ruleScopeSpecificValidators = () => [
  RequiredValidator(translateFn('Select at least one group when defining the rule for specific targets.')),
];
